import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import AppShell from "@/components/layout/AppShell";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import TenantPicker from "@/components/crm/TenantPicker";
import CrmNav, { useCrmTabs } from "@/components/crm/CrmNav";
import { StaffGrantStatus, SupportPurpose } from "@/components/area/SupportPurpose";

function CrmWorkspace({ tid, cur, tab, tick, setTick }) {
  const archived = cur.status === "archived";
  const role = archived ? "viewer" : cur.role;  // archived client: read-only for ADM too (server enforces it)
  const tabs = useCrmTabs(tid, role);
  const start = tabs.some((t) => t[0] === tab) ? tab : "sheet";
  return (
    <Tabs defaultValue={start} key={start}>
      <CrmNav tabs={tabs} />
      {archived ? <p className="mt-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600" data-testid="crm-archived-banner">Cliente archiviato: i membri non accedono più allo spazio e qui è tutto in sola lettura. Riattivalo da «Clienti» per fare modifiche.</p>
        : cur.role === "support" && <div className="mt-2 rounded-md border border-amber-200 bg-amber-50/60 px-3 py-2" data-testid="crm-support-banner">
          <p className="text-xs text-amber-800">Accesso di assistenza MUSORA: ogni accesso e ogni modifica vengono registrati e sono visibili al titolare.</p>
          <SupportPurpose tid={tid} exitTo="/crm" /><StaffGrantStatus tid={tid} /></div>}
      {tabs.map(([k, , C]) => <TabsContent key={k} value={k} className="pt-3"><C tid={tid} role={role} tenant={cur} tick={tick} onChanged={() => setTick((x) => x + 1)} /></TabsContent>)}
    </Tabs>);
}

export default function Crm() {
  const api = useApi();
  const nav = useNavigate();
  const { tid } = useParams();
  const loc = useLocation();
  const [tenants, setTenants] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => { api.get("/tenants").then(({ data }) => setTenants(data.filter((t) => t.kind === "client" && ["active", "archived"].includes(t.status)))).catch((e) => { setTenants([]); toast.error(errMsg(e)); }); }, [api]);
  const cur = tenants?.find((t) => t.id === tid);
  return (
    <AppShell>
      <div className="max-w-[1500px] space-y-6 px-5 py-8 sm:px-8 lg:px-12 lg:py-12" data-testid="crm-page">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">CRM</h1>
            <p className="mt-2 max-w-2xl text-sm text-slate-500">Richieste, contatti, opportunità, prenotazioni e ordini di ogni cliente, separati per cliente. Email solo in coda (nessun invio reale).</p></div>
          <TenantPicker tenants={tenants || []} value={tid} onChange={(v) => nav(`/crm/${v}`)} />
        </div>
        {tenants === null ? <p className="text-sm text-slate-500">Caricamento…</p> : !cur ? <p className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-sm text-slate-500" data-testid="crm-pick-tenant">Scegli un cliente per aprire il suo CRM.</p> : (
          <CrmWorkspace key={`${tid}${loc.search}`} tid={tid} cur={cur} tab={new URLSearchParams(loc.search).get("tab") || "sheet"} tick={tick} setTick={setTick} />)}
      </div>
    </AppShell>
  );
}
